import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RedirectCommand, Router } from '@angular/router';

import { map, take } from 'rxjs';

import { TicketsDataService } from '@tellent-ask-hr/tickets-logic';

@Injectable({ providedIn: 'root' })
export class TicketDialogService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private ticketsDataService = inject(TicketsDataService);

  public openTicketDialog(ticketId: number): void {
    const urlTree = this.router.createUrlTree(
      [
        {
          outlets: {
            dialog: ['ask-hr', 'ticket', ticketId],
          },
        },
      ],
      { relativeTo: this.route },
    );
    this.router.navigateByUrl(urlTree);
  }

  public resolveDialogData(route: ActivatedRouteSnapshot) {
    const ticketId = +route.paramMap.get('ticketId')!;
    return this.ticketsDataService.loadTicketById(ticketId).pipe(
      take(1),
      map(({ isSuccess }) => {
        if (!isSuccess) {
          return new RedirectCommand(
            this.router.createUrlTree([
              {
                outlets: {
                  primary: ['ask-hr', 'my', 'tickets'],
                  dialog: ['ask-hr', 'ticket-not-found'],
                },
              },
            ]),
            { skipLocationChange: true },
          );
        }

        return { ticket: this.ticketsDataService.getTicketById(ticketId) };
      }),
    );
  }
}
